<template>
  <div :class="$style.tooltipWrapper">
    <HgBadge theme="info" small>
      <strong>{{ t('moreImages.why.badge.text') }}</strong>
    </HgBadge>
    <HgTooltip :class="$style.tooltip" theme="light" @click="trackOpenTooltip">
      {{ t('moreImages.why.tooltip.text') }}
    </HgTooltip>
  </div>
</template>

<script lang="ts" setup>
import { HgBadge, HgTooltip } from '@smg-real-estate/domus';

import { EventLabel, InteractionEvent, InteractionGoal } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';
import { useI18n } from 'vue-i18n';

defineOptions({
  name: 'BlurredImageBadge',
});

const { t } = useI18n();

const trackOpenTooltip = (): void => {
  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: InteractionGoal.OPEN_TOOLTIP,
    h_event_label_008: EventLabel.VIEW_BLURRY_IMAGE_PDP,
  });
};
</script>

<style lang="scss" module>
@import '@/assets/variables';

.tooltip {
  padding: 0 0 0 $space-50;
}

.tooltipWrapper {
  display: flex;
  align-items: center;
}
</style>
